import React, { useEffect, useState } from 'react';
import { ArrowRightIcon, ChevronLeft } from 'lucide-react';
import { useLanguage } from '../components/LanguageContext';
interface Props {
  onContinue: () => void;
  onSkip: () => void;
  onBack?: () => void;
}
export function OnboardingTransition({
  onContinue,
  onSkip,
  onBack
}: Props) {
  const [mounted, setMounted] = useState(false);
  const {
    t
  } = useLanguage();
  useEffect(() => {
    const timer = setTimeout(() => setMounted(true), 100);
    return () => clearTimeout(timer);
  }, []);
  return <div className="flex flex-col h-full w-full bg-[#0D0D0D] relative overflow-hidden" data-id="element-848">
      {onBack && <button onClick={onBack} aria-label="Back" className="absolute top-6 left-6 z-50 w-10 h-10 rounded-full bg-[#1A1A1A]/80 backdrop-blur-md border border-[#2A2A2A] text-[#888888] flex items-center justify-center hover:text-white transition-colors" data-id="element-849">
          <ChevronLeft className="w-6 h-6 -ml-0.5" strokeWidth={2} data-id="element-850" />
        </button>}

      {/* Centered content */}
      <div className="flex-1 flex flex-col items-center justify-center px-6" data-id="element-851">
        {/* Green subtitle */}
        <span className="text-[12px] text-[#C5D82D] uppercase tracking-widest font-semibold mb-3 text-center" style={{
        opacity: mounted ? 1 : 0,
        transform: mounted ? 'translateY(0)' : 'translateY(12px)',
        transition: 'opacity 500ms ease, transform 500ms ease',
        transitionDelay: '100ms'
      }} data-id="element-852">
          Il tuo contributo
        </span>

        {/* Heading */}
        <h1 className="text-white text-center max-w-[320px] text-[24px] font-[500]" style={{
        opacity: mounted ? 1 : 0,
        transform: mounted ? 'translateY(0)' : 'translateY(12px)',
        transition: 'opacity 500ms ease, transform 500ms ease',
        transitionDelay: '200ms'
      }} data-id="element-853">
          {t('consent.heading')}
        </h1>
      </div>

      {/* Bottom CTA */}
      <div className="px-6 pb-8 z-10" style={{
      opacity: mounted ? 1 : 0,
      transform: mounted ? 'translateY(0)' : 'translateY(16px)',
      transition: 'opacity 500ms ease, transform 500ms ease',
      transitionDelay: '600ms'
    }} data-id="element-854">
        <p className="text-[#AAAAAA] text-[15px] text-center mb-4" data-id="element-855">
          {'Pronti ad iniziare?'}
        </p>
        <button onClick={onContinue} className="w-full py-4 rounded-full border-[1.5px] border-[#C5D82D] text-[#C5D82D] bg-transparent text-[14px] font-semibold tracking-wide flex items-center justify-center gap-2 transition-all duration-150 hover:bg-[#C5D82D]/10 active:bg-[#C5D82D]/20 active:scale-[0.98] focus-visible:bg-[#C5D82D]/15 focus-visible:outline-none" data-id="element-856">
          {t('consent.cta')}
          <ArrowRightIcon className="w-4 h-4" strokeWidth={2} data-id="element-857" />
        </button>
      </div>
    </div>;
}